import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import { selectShowLocaleSelector } from '~/components/brand/ducks/selectors';
import { isSmallerSelector } from '~/components/layout/mediaquery';
import { LocaleSelector } from '~/components/locale/async';
import MenuGlobal from '~/components/menu-global/menu-global-async';
import { ROUTE_GLOBAL } from '~/components/router/constants';
import ContextAwareRoutes from '~/components/router/context-aware-routes';
import useUIContext from '~/ui/use-ui-context';

const RoutesOverlay = () => {
	const { nativeComponentEnabled } = useUIContext();
	const smaller = useSelector(isSmallerSelector);
	const showLocaleSelector = useSelector(selectShowLocaleSelector);

	/* TODO create a route for the locale selector */
	if (showLocaleSelector) {
		return <LocaleSelector />;
	}

	return (
		<>
			<ContextAwareRoutes>
				{!nativeComponentEnabled && smaller && <Route path={ROUTE_GLOBAL} element={<MenuGlobal />} />}
			</ContextAwareRoutes>
			{/* always render MenuGlobal for native */}
			{nativeComponentEnabled && <MenuGlobal />}
		</>
	);
};

export default RoutesOverlay;
